import React from 'react'

export default function LendersDB() {
  return (
    <div>LendersDB</div>
  )
}
